import CryptoJS from "crypto-js";

const SECRET_KEY = "09876543210";

export const encryptData = (data) => {
  try {
    const stringifiedData = JSON.stringify(data);
    const encrypted = CryptoJS.AES.encrypt(
      stringifiedData,
      SECRET_KEY
    ).toString();
    return encrypted;
  } catch (error) {
    console.error("Encryption failed:", error);
    return null;
  }
};

export const decryptData = (encryptedData) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    if (!decrypted) {
      throw new Error("Decrypted data is empty");
    }
    return JSON.parse(decrypted);
  } catch (error) {
    console.error("Decryption failed:", error);
    return null;
  }
};
